import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import {
  MuiTextFieldFrom,
  MuiTextFieldFromSelect,
  MuiTextFieldFromSendButton,
} from "components/view/text_field_from";
import { MaxButton, StatusMaxButton } from "components/view/button";
import { CenterProps } from "lib/all_type/center_props";
import LayoutMaster from "components/layout/layout_master";
import Link from "next/link";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
} from "lib/infomation_vender/document";
import { GetServerSideProps } from "next";
import {
  apigetbankonlywebsite,
  GetBankTypeAllResponse,
} from "lib/worker/api/get_bank_type_all";
import { SendOTPUpdateBankResponse } from "lib/worker/api/send_otp_update_bank";
import { alertWithMessage } from "components/modal/message_modal";
import register_on_website_full_chain from "lib/worker/api/register_on_website_full_chain";
import send_otp_update_bank_for_register_full from "lib/worker/api/send_otp_update_bank_for_register_full";
import { MenuItem } from "@mui/material";
import Img from "react-cloudimage-responsive";
import information_ref_id, {
  InformationRefIDResponse,
} from "lib/worker/api/information_ref_id";

interface RegisterPageProps extends CenterProps {
  prefix: string;
  token?: string;
  banks: GetBankTypeAllResponse[];
  infomation: CheckWithPrefixResponse;
}

function RegisterPage(props: RegisterPageProps) {
  const [password, setpassword] = useState<string>("");
  const [fullname, setfullname] = useState<string>("");
  const [banknumber, setbanknumber] = useState<string>("");
  const [tel, settel] = useState<string>("");
  const [bankaccountID, setBankAccountID] = useState<number>();
  const [otp, setotp] = useState<string>("");
  const [otpoinof, setotpinfo] = useState<SendOTPUpdateBankResponse>();
  const [step, setstep] = useState<number>(0);
  const router = useRouter();
  const [loadingregister, setloadingregister] = useState<boolean>(false);
  const [refInfomration, setRefInformation] =
    useState<InformationRefIDResponse>();
  const [countotp, setcountotp] = useState<number>(30);

  useEffect(() => {
    if (
      localStorage.getItem("ref_token") == null ||
      localStorage.getItem("ref_token") == ""
    ) {
      localStorage.setItem("ref_token", props.token ?? "");
    }

    information_ref_id({ hash: localStorage.getItem("ref_token") }).then(
      setRefInformation
    );
  }, []);

  useEffect(() => {
    let countdown = setInterval(() => {
      if (otpoinof == undefined) {
        return;
      }
      if (countotp <= 0) {
        setotpinfo(undefined);
        setcountotp(30);
        return;
      }
      const newcount = countotp - 1;
      setcountotp(newcount);
    }, 1000);

    return () => {
      clearInterval(countdown);
    };
  }, [countotp, otpoinof]);

  const goStep2 = () => {
    if (tel == "") {
      alertWithMessage("กรุณากรอกเบอร์โทรศัพท์");
      return;
    }

    if (otp == "") {
      alertWithMessage("กรุณาระบุ OTP");
      return;
    }

    if (password == "") {
      alertWithMessage("กรุณากรอกรหัสผ่าน");
      return;
    }

    setstep(1);
  };

  const onOTP = async () => {
    try {
      const responseOTP = await send_otp_update_bank_for_register_full({
        prefix: props.prefix,
        tel: tel,
      });

      setotpinfo(responseOTP);
    } catch (error: any) {
      alertWithMessage(error.response.data.message);
    }
  };

  const onRegister = async () => {
    if (bankaccountID == undefined) {
      alertWithMessage("กรุณาระบุธนาคารของท่าน");
      return;
    }

    if (fullname == "") {
      alertWithMessage("กรุณากรอกชื่อ - นามสกุล");
      return;
    }

    if (banknumber == "") {
      alertWithMessage("กรุณากรอกเลขที่บัญชี");
      return;
    }

    setloadingregister(true);

    try {
      await register_on_website_full_chain({
        prefix: props.prefix,
        username: tel,
        password: password,
        tel: tel,
        currency_id: 1,
        ref_id: localStorage.getItem("ref_token") ?? undefined,
        ref_redirect: localStorage.getItem("redirect"),
        token: otpoinof?.data?.token ?? "",
        otp: otp,
        full_name: fullname,
        bank_type_id: bankaccountID,
        bank_name: fullname,
        bank_number: banknumber,
      });

      goToHome();
    } catch (error: any) {
      alertWithMessage(error.response.data.message);
    }

    setloadingregister(false);
  };

  const goToHome = () => {
    router.push("/");
  };

  const checkVenderDisableRegister = (): boolean => {
    if (props.infomation.disableRegister) {
      if (refInfomration == null) {
        return true;
      }
      return false;
    }

    return false;
  };

  const controlStep = () => {
    switch (step) {
      case 0:
        return (
          <div>
            <h1 className="text-center">
              สมัครสมาชิก {refInfomration?.Name ? "*มีผู้แนะนำ" : ""}
            </h1>
            <div className="row center-row-content" style={{ paddingTop: 10 }}>
              <p className="bottom-line-regis margin-right-10"></p>
              <p className="bottom-line-regis" style={{ opacity: 0.5 }}></p>
            </div>

            <div>
              <MuiTextFieldFromSendButton
                className="margin-top-20"
                title="เบอร์โทรศัพท์"
                titleButton={
                  otpoinof != undefined ? `${countotp} s` : "ส่ง OTP"
                }
                disableButton={otpoinof != undefined}
                value={tel}
                type="phonenumber"
                onChange={(e) => {
                  settel(e.target.value);
                }}
                onClick={onOTP}
              ></MuiTextFieldFromSendButton>
            </div>
            <div className="margin-top-10">
              <MuiTextFieldFrom
                title={"ระบุ OTP"}
                value={otp}
                type="otp"
                className="margin-top-20"
                onChange={(e) => {
                  setotp(e.target.value);
                }}
              ></MuiTextFieldFrom>
            </div>
            <div className="margin-top-20">
              <MuiTextFieldFrom
                title="รหัสผ่าน"
                value={password}
                despication="รหัสผ่าน (สำหรับเข้าใช้งาน *6 ตัวอักษรขึ้นไป)"
                type="password"
                onChange={(e) => {
                  setpassword(e.target.value);
                }}
              ></MuiTextFieldFrom>
            </div>

            <MaxButton
              title="ถัดไป"
              status={StatusMaxButton.submit}
              className="margin-top-20"
              onClick={goStep2}
            ></MaxButton>

            <MaxButton
              title="ไปหน้าหลัก"
              onClick={goToHome}
              className="margin-top-10"
              status={StatusMaxButton.back}
            ></MaxButton>
          </div>
        );
      case 1:
        return (
          <div>
            <h1 className="text-center">ยืนยันธนาคาร</h1>
            <div className="row center-row-content" style={{ paddingTop: 10 }}>
              <p
                className="bottom-line-regis margin-right-10"
                style={{ opacity: 0.5 }}
              ></p>
              <p className="bottom-line-regis"></p>
            </div>

            <div className="margin-top-10">
              <MuiTextFieldFrom
                title="ชื่อจริง - นามสกุล"
                type="firstname"
                value={fullname}
                onChange={(e) => {
                  setfullname(e.target.value);
                }}
              ></MuiTextFieldFrom>
            </div>
            <MuiTextFieldFromSelect title="ธนาคาร" className="margin-top-20">
              {props.banks.map((value) => {
                return (
                  <MenuItem
                    key={value.ID}
                    value={value.ID}
                    onClick={() => {
                      setBankAccountID(value.ID);
                    }}
                  >
                    <div
                      style={{
                        height: 30,
                        width: 30,
                        borderRadius: 4,
                        backgroundColor: value.Color ?? "white",
                        float: "left",
                      }}
                    >
                      <div style={{ padding: 3 }}>
                        <Img src={value.Image ?? ""}></Img>
                      </div>
                    </div>{" "}
                    <div
                      style={{
                        float: "left",
                        marginLeft: 10,
                        marginTop: 3,
                      }}
                    >
                      {value.Type}
                    </div>
                  </MenuItem>
                );
              })}
            </MuiTextFieldFromSelect>

            <div className="margin-top-20">
              <MuiTextFieldFrom
                title="เลขที่บัญชี"
                value={banknumber}
                onChange={(e) => {
                  setbanknumber(e.target.value);
                }}
                type="banknumber"
              ></MuiTextFieldFrom>
            </div>

            <MaxButton
              title="ยืนยันธนาคาร"
              status={StatusMaxButton.submit}
              className="margin-top-20"
              onClick={onRegister}
              loading={loadingregister}
            ></MaxButton>

            <MaxButton
              title="กลับ"
              onClick={() => {
                setstep(0);
              }}
              className="margin-top-10"
              status={StatusMaxButton.back}
            ></MaxButton>
          </div>
        );
      default:
        return <></>;
    }
  };

  if (checkVenderDisableRegister()) {
    return (
      <LayoutMaster
        content_setting={{
          title: "สมัครสมาชิก คาสิโนออนไลน์",
          description:
            "ให้บริการ กีฬาออนไลน์ แทงบอลออนไลน์ คาสิโน เต็มรูปแบบ พร้อมให้บริการ ทุกท่านตลอด 24 ชั่วโมง ทั้งยังมี โบนัสแจก ให้กับลูกค้าทุกท่าน ไม่มีฝากเงินขั้นต่ำ",
        }}
        information={props.infomation}
      >
        <div
          className="container margin-bottom-padding"
          style={{ marginTop: 80 }}
        >
          <h1 className="text-center">
            ปิดรับสมาชิก {refInfomration?.Name ? "*มีผู้แนะนำ" : ""}
          </h1>
        </div>
      </LayoutMaster>
    );
  }

  return (
    <LayoutMaster
      content_setting={{
        title: "สมัครสมาชิก คาสิโนออนไลน์",
        description:
          "ให้บริการ กีฬาออนไลน์ แทงบอลออนไลน์ คาสิโน เต็มรูปแบบ พร้อมให้บริการ ทุกท่านตลอด 24 ชั่วโมง ทั้งยังมี โบนัสแจก ให้กับลูกค้าทุกท่าน ไม่มีฝากเงินขั้นต่ำ",
      }}
      information={props.infomation}
    >
      <div className="bg-form-snam">
        <div className="container" style={{ marginTop: 30 }}>
          <div
            style={{
              paddingTop: 10,
              paddingBottom: 200,
              paddingLeft: 10,
              paddingRight: 10,
            }}
          >
            <div
              className="container margin-top-10"
              style={{ paddingTop: 20, paddingBottom: 20, borderRadius: 10 }}
            >
              {controlStep()}
            </div>
            <h2
              className="font-red margin-top-20"
              style={{ fontSize: 16, marginLeft: 10 }}
            >
              *พบปัญหากรุณาติดต่อเจ้าหน้าที่ผ่านช่องทางแชท{" "}
              <Link href={props.infomation.lineidchat ?? ""}>
                <a>
                  <span>คลิก</span>
                </a>
              </Link>
            </h2>
          </div>
        </div>
      </div>
    </LayoutMaster>
  );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { req } = context;
  const infomation = CheckWithPrefix({ host: req.headers.host as string });
  const token = context.query.token ?? null;
  try {
    const banks = await apigetbankonlywebsite({ prefix: infomation.prefix });
    return {
      props: {
        prefix: infomation.prefix,
        token: token,
        banks: banks,
        infomation: infomation,
      },
    };
  } catch (error) {
    return {
      props: {
        prefix: infomation.prefix,
        token: null,
        banks: [],
        infomation: infomation,
      },
    };
  }
};

export default RegisterPage;
